<template>
  <div class="text-center">
    <iframe :src="link" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: "DocumentacionIframe",
  data() {
    return {
      link:
        "https://knowledgebase.pargolfsolutions.com/eyJhYyI6NCwidHkiOjAsInRuIjoyLCJ0ZW5hbnRfbmFtZSI6IlBhcmdvbGYgQWRtaW4ifQ==",
    };
  },
  mounted() {
    document.querySelectorAll("iframe")[0].style =
      "height: 85vh !important;  width:95vw;";
  },
  created() {},
};
</script>
